
import { mapState, mapActions } from "vuex";
import BackButtonWithBlankLogo from "../common/back-botton-with-blank-logo.vue";
import smsOtp from "~/assets/images/smsOtp.svg";

export default {
  components: { BackButtonWithBlankLogo },
  name: "SignupOtpVerification",
  data() {
    return {
      smsOtp,
      otp: "",
      resetData: {},
      formError: "",
      loading: false,
      valid: true,
      otpTimer: 0,
      resendOtpTimer: 0,
      otpIntervalID: "",
      otpResendIntervalID: "",
      otpRules: [
        (v) => !!v || "OTP is required",
        (v) => /\d{6}/.test(v) || "Sorry! Invalid OTP"
      ]
    };
  },
  props: {
    resetDataProp: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.resetData = JSON.parse(JSON.stringify(this.resetDataProp));
    this.startOtpTimer();
  },
  computed: {
    otpChannel() {
      return (
        this.resetDataProp.otpRequest.mobile_number ||
        this.resetDataProp.otpRequest.email
      );
    }
  },
  methods: {
    ...mapActions("auth", [
      "requestForgotPasswordpOtp",
      "verifyForgotPasswordOtp"
    ]),
    startOtpTimer() {
      clearInterval(this.otpIntervalID);
      this.otpTimer = 15 * 60;
      this.otpIntervalID = setInterval(this.decreaseOtpTimer, 1000);
    },
    decreaseOtpTimer() {
      this.otpTimer--;
      if (this.otpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    startOtpResendTimer() {
      this.startOtpTimer();
      clearInterval(this.otpResendIntervalID);
      this.resendOtpTimer = 2 * 60;
      this.otpResendIntervalID = setInterval(this.decreaseOtpResendTimer, 1000);
    },
    decreaseOtpResendTimer() {
      this.resendOtpTimer--;
      if (this.resendOtpTimer == 0) {
        clearInterval(this.otpResendIntervalID);
      }
    },
    validateForm() {
      this.valid = this.$refs.formOtp.validate();
    },
    submitOtp() {
      this.validateForm();
      if (this.valid) {
        this.loading = true;
        this.verifyForgotPasswordOtp({
          otp_code: this.otp.toString(),
          otp_token: this.resetData.otpResponse.otp_token,
          mobile_number: this.resetData.otpRequest.mobile_number
        })
          .then((response) => {
            if (response.data.status === "success") {
              this.resetData.otp_code = this.otp.toString();
              this.$emit("otp-verified", this.resetData);
            } else {
              this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resendOtp() {
      this.requestForgotPasswordpOtp(this.resetData.otpRequest)
        .then((response) => {
          this.startOtpResendTimer();
          this.resetData.otpResponse = response.data;
          this.$nuxt.$emit("show-toast", {
            text: response.data.message,
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("otp-sent", this.resetData);
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        });
    }
  }
};
